<template>
  <div class="outer-carousel-wrapper" v-if="isShow" @click="close">
    <div class="model-content" @click.stop="stopClick">
      <!-- <img src="../assets/images/outer/back.png" alt=""> -->
      <!-- <el-carousel height="150px">
        <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel> -->
      <div class="top-content">
        <div class="title">保险智能云全新版本来袭</div>
        <div class="tip">V5-AI创收版全新上线，AI微信工作台，AI报价机器人，AI数字营销，AI增员激励，保险商城，车主服务。</div>
        <div class="tip">六大能力助力企业营收增长利润翻倍。</div>
        <img src="../assets/images/outer/rocket.png" alt="" class="rocket-image">
        <i class="el-icon-close close-icon" @click="close"></i>
      </div>
      <el-carousel class="bottom-content" trigger="click" :autoplay="false">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div class="carousel-content">
            <div class="left-content">
              <div class="left-item" v-for="(ite, idx) in item.list" :key="idx" @click.stop="chooseTab(item.name, ite.icon)" :class="{'active': form[item.name] === ite.icon}">
                <div class="title-content">
                  <img :src='require(`@/assets/images/outer/${ite.icon}-icon.png`)' alt="" class="left-icon">
                  <span class="left-title">{{ ite.title }}</span>
                </div>
                <div class="left-detail">{{ ite.content }}</div>
              </div>
            </div>
            <div class="right-content" :class="form[item.name]">
              <!-- <img :src='require(`@/assets/images/outer/${form[item.name]}.png`)' class="right-image" alt=""> -->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import { day } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'outer-carousel',
  data () {
    return {
      list: [
        {
          name: 'secondActive',
          list: [
            {
              icon: 'wechat',
              title: 'AI微信工作台',
              content: '通过微信进行报价，轻松承接服务500+业务群。平均10秒完成一个报价。报价更及时，服务更贴心，成交更简单。'
            },
            {
              icon: 'quote',
              title: 'AI报价机器人',
              content: '专注接单，智能报价，精准高效。让车险交易更加简单。'
            },
            {
              icon: 'marketing',
              title: 'AI数字营销',
              content: '车主，业务员，出单员一体激励。让每一次数字营销都充满智慧与温度。'
            }
          ]
        },
        {
          name: 'firstActive',
          list: [
            {
              icon: 'increase',
              title: 'AI增员激励',
              content: '新人专属即时奖励，让团队动力无限。'
            },
            {
              icon: 'mall',
              title: '保险商城',
              content: '机构一键签约，轻松实现优质产品下发推广。推广佣金即时提现，即刻到账。'
            },
            {
              icon: 'carOwner',
              title: '车主服务',
              content: '车主专属大礼包，以专属大礼包为基础与客户搭建沟通桥梁。让车险交易成为长期交易，贯穿客户整个生命周期。'
            }
          ]
        }
      ],
      form: {
        firstActive: 'increase',
        secondActive: 'wechat'
      },
      dateList: [],
      isShow: false
    }
  },
  created () {
    try {
      const dateList = JSON.parse(localStorage.getItem('latestDate') || '[]')
      // 数据格式不对，清空缓存，处理老数据格式问题
      if (!Array.isArray(dateList)) {
        localStorage.removeItem('latestDate')
        this.isShow = true
        return
      }
      this.dateList = dateList
      let item = dateList.some(c => c.id === this.CustomerId && c.date === day.nowF())
      if (!item && location.pathname !== '/login') {
        this.isShow = true
        return
      }
      this.isShow = false
    } catch (e) {
      this.isShow = true
      localStorage.removeItem('latestDate')
    }
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER && this.CUSTOMER_LOGINCUSTOMER.data
    },
    CustomerId () {
      return this.userInfo && this.userInfo.CustomerId
    }
  },
  methods: {
    chooseTab (name, value) {
      console.log(name, value)
      this.form[name] = value
    },
    stopClick (e) {
      e.stopPropagation()
    },
    close () {
      const dateList = this.dateList.filter(c => { return c.id !== this.CustomerId }) || []
      dateList.push({
        id: this.CustomerId,
        date: day.nowF()
      })
      localStorage.setItem('latestDate', JSON.stringify(dateList))
      this.isShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.outer-carousel-wrapper {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 10000;
  height: 100vh;
  width: 100vw;
  background-color: rgba(7, 17, 27, 0.4);
  .model-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    width: 1000px;
    height: 610px; // 592px;
    // width: 80%; /* 子元素的宽度 */
    // min-width: 1000px;
    // height: 80%;
    // min-height: 800px; /* 子元素的高度 */
    background-image: url("../assets/images/outer/back.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    padding: 30px 40px;
    box-sizing: border-box;
  }
  .top-content {
    color: #fff;
    height: 120px;
    padding-right: 40px;
    position: relative;
    padding-top: 15px;
    box-sizing: border-box;
    .close-icon {
      font-size: 20px;
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
    .title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .tip {
      width: 600px;
      font-size: 12px;
      margin-bottom: 5px;
    }
    .rocket-image {
      height: 170px;
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
  .bottom-content {
    width: 100%;
    height: calc(100% - 120px);
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    box-sizing: border-box;
    border-radius: 13px;
    box-shadow: inset 0px 2px 10px 0px rgba(7, 17, 27, 0.1);
    .carousel-content {
      display: flex;
      height: calc(100% - 10px);
    }
    .left-content {
      width: 280px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .left-item {
        flex: 1;
        // border: 1px solid #ddd;
        padding: 10px;
        margin-bottom: 10px;
        // background-color: #d1e3ff;
        border-radius: 13px;
        cursor: pointer;
        &.active {
          background-color: #d1e3ff;
        }
        .title-content {
          height: 30px;
          line-height: 30px;
          .left-icon {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
          }
          .left-title {
            font-size: 14px;
            font-weight: 700;
            vertical-align: middle;
          }
        }
        .left-detail {
          font-size: 12px;
          padding-left: 22px;
          color: #666;
        }
      }
    }
    .right-content {
      background-color: #fff;
      width: calc(100% - 280px);
      margin-left: 20px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      .right-image {
        width: 100%;
        border-radius: 20px;
      }
      &.increase{
        background-image: url("../assets/images/outer/increase.png");
      }
      &.mall{
        background-image: url("../assets/images/outer/mall.png");
      }
      &.carOwner{
        background-image: url("../assets/images/outer/carOwner.png");
      }
      &.wechat{
        background-image: url("../assets/images/outer/wechat.png");
      }
      &.quote{
        background-image: url("../assets/images/outer/quote.png");
      }
      &.marketing{
        background-image: url("../assets/images/outer/marketing.png");
      }
    }
  }
  /deep/.el-carousel__container {
    height: 100%;
  }
  /* 自定义 el-carousel indicator 颜色 */
  /deep/.el-carousel__button {
    background-color: #9ac2ff; /* 你想要的颜色 */
  }
  /* 隐藏 el-carousel 的左右切换按钮 */
  /deep/.el-carousel__arrow {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/outerCarousel.vue